import Vue from 'vue'
import App from './App.vue'
import router from './router'
/*饿了么的UI*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import leftMenu from './layout/left-menu';
import topHeader from './layout/top-header';
import store from './store'

import {checkToken, LOGIN_SUCCESS} from "./api/api";

import '../assets/ele/index.css'

Vue.config.productionTip = false;

Vue.component('leftMenu', leftMenu);
Vue.component('topHeader', topHeader);
Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
    checkToken().then(result => {
        //console.log(result);
        if (result.code === LOGIN_SUCCESS) {
            let data = result.data;
            store.state.avatar = data.avatar;
            store.state.roleId = data.roleId;
            store.state.userName = data.userName;
            store.state.userId = data.id;
            store.state.companyId = data.companyId;
            store.state.companyName = data.companyName;
            //后面再处理其他的权限吧
            if (to.path === '/login' || to.path === '/register') {
                next({path: '/'})
            } else {
                next();
            }
        } else {
            if (to.path === '/register') {
                //跳转到注册界面
                next({
                    path: '/register'
                });
            } else {
                //跳转到登录界面
                next({
                    path: '/login'
                });
            }
        }

    }, error => {
        console.log(error);
        next({
            path: '/login'
        })
    });
    next();
});
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
